import { FormatLetterItemType, ProvinceType } from './type';

export function detectScroll(container: HTMLElement, className: string, index: number) {
    const itemList = container.getElementsByClassName(className);

    if (itemList) {
        const wrapperHeight = container.getBoundingClientRect().height;
        const activeItem = Array.from(itemList)[index];

        if (activeItem) {
            const itemHeight = activeItem.getBoundingClientRect().height;
            const offsetTop = (activeItem as HTMLElement).offsetTop;
            const scrollTop = container.scrollTop;
            let scroll = scrollTop;

            if (scrollTop < offsetTop - wrapperHeight + itemHeight) {
                scroll = offsetTop - wrapperHeight + itemHeight;
            } else if (scrollTop > offsetTop) {
                scroll = offsetTop;
            }

            scrollToTop(container, scroll);
        }
    }
}

export function scrollToTop(element: Element, top: number) {
    if (element?.scrollTo) {
        element.scrollTo({
            top,
            behavior: 'smooth'
        });
    } else {
        element.scrollTop = top;
    }
}

export function formatLetter(data: ProvinceType[]) {
    const formatData: Record<string, FormatLetterItemType> = {};

    data.forEach(item => {
        const letter = item.pinyin.slice(0, 1).toUpperCase();

        if (formatData[letter]) {
            formatData[letter].province.push(item);
        } else {
            formatData[letter] = {
                letter,
                province: [item]
            };
        }
    });

    return Object.keys(formatData)
        .sort()
        .map(key => formatData[key]);
}
